import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_eqqcazcfku: FaireBrandEntity = {
  token: "b_eqqcazcfku",
  type: "brand",
  name: "JESSA Jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/07b42c7a6d8b7b65468b5709f12a00598a0bd27eb4f38d5912c9a74244f89e39.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/0e6f0ea30119e10d30e853bfe8bb2712aa0aa64e787e751ce30029d93e13a9dd.png",
  logoUrl:
    "https://cdn.faire.com/fastly/07b42c7a6d8b7b65468b5709f12a00598a0bd27eb4f38d5912c9a74244f89e39.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0e6f0ea30119e10d30e853bfe8bb2712aa0aa64e787e751ce30029d93e13a9dd.png",
  location: "Philadelphia, PA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 91,
  isTopShop: true,
  isInsider: true,
  description:
    "JESSA JEWELRY is a female, Asian-owned brand that’s all about giving you timeless, high-quality pieces without breaking the bank! We’re all for keeping things simple—our jewelry is easy to care for, easy to love, and easily to be worn daily. Crafted from stainless steel so all our jewelry is hypoallergenic, tarnish-free and water resistant. Our pieces are designed to stand the test of time, ensuring that your jewelry remains a part of your collection for years to come!\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:13.337Z",
    importedBy: "entity-db-cli",
  },
};
